import { useHistory } from 'react-router-dom';
import {
  IonModal,
  IonContent,
  IonText,
  IonIcon,
  IonRippleEffect,
  IonButton
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

import { ReactComponent as StoryIcon } from './assets/story.svg';
import { ReactComponent as WorkoutIcon } from './assets/workouts.svg';
import { ReactComponent as FuelingPlanIcon } from './assets/fueling-plan.svg';
import { ReactComponent as EducationalResourceIcon } from './assets/educational-resources.svg';
import { ReactComponent as FileExplorerIcon } from './assets/file-explorer.svg';
import { ReactComponent as DashboardIcon } from './assets/dashboard.svg';
import { ReactComponent as ReportIcon } from './assets/report.svg'
import bottomContainer from './assets/bottom-container-back.png';

import { capitalize } from 'libs/helpers/helper.lib';

import classes from './style.module.scss';

const menuItems = [
  {
    name: 'stories',
    icon: <StoryIcon className={classes.menuItemIcon} />,
    path: '/stories'
  },
  {
    name: 'workout',
    icon: <WorkoutIcon className={classes.menuItemIcon} />,
    path: '/workouts'
  },
  {
    name: 'fueling plan',
    icon: <FuelingPlanIcon className={classes.menuItemIcon} />,
    path: '/fueling-plans'
  },
  {
    name: 'file explorer',
    icon: <FileExplorerIcon className={classes.menuItemIcon} />,
    path: '/file-explorer'
  },
  {
    name: 'educational',
    icon: <EducationalResourceIcon className={classes.menuItemIcon} />,
    path: '/educational-resources'
  },
  {
    name: 'Reports',
    icon: <ReportIcon className={classes.menuItemIcon} />,
    path: '/reports/readiness-progress'
  }
];

const BottomDrawer = ({ isOpen, close }) => {
  const { push } = useHistory();

  return (
    <IonModal
      isOpen={isOpen}
      breakpoints={[0, 0.2, 0.5, 1]}
      initialBreakpoint={1}
      swipeToClose={true}
      onDidDismiss={close}
      cssClass={classes.ionModal}
    >
      <IonContent className={classes.ionContent}>
        <div className={classes.mainContent}>
          <div className={classes.menuItemContainer}>
            {menuItems.map((item) => (
              <div
                className={`${classes.menuItem} ion-activatable`}
                onClick={() => {
                  close();
                  push(item.path);
                }}
                key={item.name}
              >
                {item.icon}
                <IonText className={classes.menuItemText}>
                  {capitalize(item.name)}
                </IonText>
                <IonRippleEffect></IonRippleEffect>
              </div>
            ))}
          </div>
          <div className={classes.bottomContainer}>
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 287.93">
              <path class="cls-1" d="M1130.46,180.97c-83.02-5.11-162.91-39-223.47-95.53-16.53-15.43-30.64-35.01-47.97-49.03-62.41-50.5-152.8-48.46-212.03,6-10.66,9.8-18.73,21.91-28.47,32.53-57.41,62.58-135.6,100.69-220.97,106.03l-397.54-.04v107h1500v-107l-369.54.04Z" fill="var(--ion-background-color-secondary)"/>
            </svg>
            <IonButton fill='clear' color='primary' onClick={close}>
              <IonIcon slot='icon-only' icon={closeOutline} size='large' />
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default BottomDrawer;
